/** @jsxImportSource @emotion/react */

import { css } from '@emotion/react'
import { Fragment, ReactElement } from 'react';
import { genJyuuGothicBold } from '../../fonts/FontFace'
import { useDecorateWebviewUrl } from '../../lib/useDecorateWebviewUrl'
import { NewsComponentProp } from '../../types'

type Props = {
  component: NewsComponentProp
  key: number
}

function NewsComponent({ component }: Props): ReactElement {
  const articleTextWrapperStyle = (i: number) => css`
    padding: 0 0 0 10px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    height: 92px;
    padding-bottom: 12px;
    ${i !== component.newsArticles.length - 1
      ? 'border-bottom: 1px solid rgba(0, 0, 0, 0.04);'
      : ''}
  `
  const decorateWebviewUrl = useDecorateWebviewUrl()

  return (
    <Fragment>
      <div css={newsComponentStyle} className="news_component">
        {component.title && (
          <h2 css={titleStyle(component.titleColor)}>
            {component.title.split(/\n/).map((leadElement, i) => (
              <Fragment key={i}>
                {leadElement}
                <br />
              </Fragment>
            ))}
          </h2>
        )}
        <ul css={{ listStyle: 'none', margin: 0, padding: 0 }}>
          {component.newsArticles.map((newsArticle, i) => {
            return (
              <li key={i} css={articleStyle}>
                <a href={decorateWebviewUrl(newsArticle.url)} css={articleLinkStyle}>
                  <img src={newsArticle.image.url} width="80" height="80" css={articleImageStyle} />
                  <div css={articleTextWrapperStyle(i)}>
                    <div css={articleTitleStyle}>{newsArticle.title}</div>
                    <div css={articleSiteNameStyle}>{newsArticle.siteName}</div>
                  </div>
                </a>
              </li>
            )
          })}
        </ul>
      </div>
    </Fragment>
  );
}

const newsComponentStyle = css`
  margin-bottom: 24px;
  padding: 24px 12px 0 12px;
`

const titleStyle = (titleColor: string) => css`
  ${genJyuuGothicBold}
  font-size: 20px;
  color: ${titleColor};
  text-align: center;
  margin-top: 0;
  line-height: 30px;
`

const articleStyle = css`
  padding: 12px 0 0 0;
`

const articleLinkStyle = css`
  text-decoration: none;
  color: black;
  display: flex;
`

const articleImageStyle = css`
  width: 80;
  height: 80;
  border-radius: 4px;
  display: block;
`

const articleTitleStyle = css`
  margin-bottom: 0;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 14px;
  line-height: 20px;
  width: 100%;
  font-weight: bold;
  text-decoration: underline;
  color: rgb(60, 28, 28);
`

const articleSiteNameStyle = css`
  width: 100%;
  align-self: flex-end;
  bottom: 12px;
  font-family: 'Hiragino Kaku Gothic Pro';
  font-size: 12px;
  line-height: 12px;
  color: gray;
`

export default NewsComponent
